import * as Mod1 from "./discourse-akismet/connectors/flag-modal-bottom/akismet-status.gjs";
import * as Mod2 from "./discourse-akismet/connectors/topic-above-post-stream/topic-removed-notification.gjs";
import * as Mod3 from "./discourse/components/reviewable-akismet-api-error";
import * as Mod4 from "./discourse/components/reviewable/akismet-post-voting-comment";
import * as Mod5 from "./discourse/components/reviewable/akismet-post";
import * as Mod6 from "./discourse/components/reviewable/akismet-user";
import * as Mod7 from "./discourse/initializers/add-akismet-state";
const compatModules = {
  "discourse-akismet/connectors/flag-modal-bottom/akismet-status": Mod1,
  "discourse-akismet/connectors/topic-above-post-stream/topic-removed-notification": Mod2,
  "discourse/components/reviewable-akismet-api-error": Mod3,
  "discourse/components/reviewable/akismet-post-voting-comment": Mod4,
  "discourse/components/reviewable/akismet-post": Mod5,
  "discourse/components/reviewable/akismet-user": Mod6,
  "discourse/initializers/add-akismet-state": Mod7,
};
export default compatModules;
